import React from 'react';

import image from '../../assets/img_candidate_profile.png';

import styles from './WhyItWorks.scss';

const jobBoardsData = [
  ['Effort', 'High', 'Low'],
  ['Time to Hire', 'Slow', 'Fast'],
  ['Quality', 'Inconsistent', 'Vetted & engaged'],
  ['Support', 'None', 'Self-serve to full-service'],
  ['Pricing', '$200–$500/post', 'From $1K/month'],
];

const WhyItWorks = () => {
  return (
    <div id="Why-join" className={styles.WhyItWorks}>
      <div className={styles.Container}>
        <div className={styles.Wrapper}>
          <div className={styles.Column1}>
            <h3 className={styles.SecondaryTitle}>Why It Works</h3>
            <div className={styles.Description}>
              <ul>
                <li>Candidates are pre-vetted and opt-in</li>
                <li>Job boards waste time—we won’t</li>
                <li>Transparent pricing, no fluff</li>
                <li>Use us on your terms—no long-term lock-in</li>
              </ul>
            </div>
          </div>
          <div className={styles.Column2}>
            <img src={image} alt="Top sales talent" className={styles.Image} />
          </div>
        </div>
        <div>
          <h3 className={styles.SecondaryTitle2}>Say ‘Goodbye’ to Job Boards</h3>
          <table className={styles.jobBoardsTable}>
            <tr>
              <th> </th>
              <th className={styles.underline}>Job Boards</th>
              <th className={styles.underline}>Rainmakers</th>
            </tr>
            <>
              {jobBoardsData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item[0]}</td>
                    <td>{item[1]}</td>
                    <td>{item[2]}</td>
                  </tr>
                );
              })}
            </>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WhyItWorks;
